module.exports = __webpack_public_path__ + "static/img/screen2.4769203.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/screen2.png
// module id = W9Bx
// module chunks = 1